import Parent from './parent';
import Child from './child';

/**
 * Expose Parent and Child modules on AcrossTabs Object
 * @type {Object}
 */
const AcrossTabs = {
  Parent: Parent,
  Child: Child
};

export default AcrossTabs;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/